var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFooterFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.27 6.20312V14.2031C19.27 16.9645 17.0314 19.2031 14.27 19.2031H6.27002C3.5086 19.2031 1.27002 16.9645 1.27002 14.2031V6.20312C1.27002 3.4417 3.5086 1.20312 6.27002 1.20312H14.27C17.0314 1.20312 19.27 3.4417 19.27 6.20312Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27002 19.2031C9.27002 16.2031 9.27002 13.2031 9.27002 10.2031C9.27002 8.01562 9.77002 6.20312 13.27 6.20312",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27002 11.2031H9.27002H13.27",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFooterFb);
export default __webpack_public_path__ + "static/media/ic_footer_fb.aed29b50fb809869080993e84587c821.svg";
export { ForwardRef as ReactComponent };